import { useGetAllLives } from '@/app/hooks/useGetAllLives'
import { Button } from '@/view/components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useState } from 'react'
import { LiveCard } from './live-card/LiveCard'

export const LiveList = () => {
  const [skip, setSkip] = useState(0)
  const limit = 3

  const { data, error } = useGetAllLives({
    skip,
    limit,
    search: '',
  })

  const currentPage = skip / limit + 1

  const totalPages = Math.ceil((data?.total ?? 0) / limit)

  const handlePreviousClick = () => {
    const newSkip = Math.max(0, skip - limit)
    setSkip(newSkip)
  }

  const handleNextClick = () => {
    const newSkip = Math.min(skip + limit, (totalPages - 1) * limit)
    setSkip(newSkip)
  }

  if (error) return <div>Error: {error?.message}</div>

  return (
    <aside className="flex min-w-[368px] flex-col gap-4 border-l p-8">
      <h1 className="text-[#0C0E13]">Ao vivo</h1>
      <>
        {data?.lives.map((live) => <LiveCard key={live?._id} live={live} />)}

        <div className="mt-4 flex items-center justify-end gap-2">
          <Button variant="ghost" onClick={handlePreviousClick}>
            <ChevronLeft />
          </Button>
          <div className="mx-4 flex gap-2">
            {currentPage} de {totalPages}
          </div>
          <Button variant="ghost" onClick={handleNextClick}>
            <ChevronRight />
          </Button>
        </div>
      </>
    </aside>
  )
}
